import React from "react";
import { Close } from "../_icons/Close.tsx";
import { LoadingDots } from "../LoadingDots/LoadingDots.tsx";
import styles from "./DialogHeader.module.css";

export interface DialogHeaderProps {
  title: string;
  onClose?: () => void;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  onClose,
  loading,
  children,
  className,
}) => {
  return (
    <div className={`${styles.Header} ${className || ""}`}>
      <h2 className={styles.Title}>
        {title}
        {loading && <LoadingDots />}
      </h2>
      <div className={styles.Actions}>
        {children}
        {onClose && (
          <button
            className={styles.CloseButton}
            onClick={onClose}
            aria-label="Close"
            type="button"
          >
            <Close />
          </button>
        )}
      </div>
    </div>
  );
};
